var _Rect, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Rect, G, Circle, Path } from "react-native-svg";
var SvgReportInappropriate = function SvgReportInappropriate(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 17.2,
    height: 15.2,
    x: 3.4,
    y: 4.4,
    stroke: "#FF4D3D",
    strokeWidth: 1.8,
    rx: 2.1
  })), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#FF4D3D",
    transform: "translate(4.5 5.5)"
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: 12,
    cy: 2.8,
    r: 1.4
  }), /*#__PURE__*/React.createElement(Path, {
    d: "m.8 13 4.4-5.3 2.7 3.2 2-2.4 4.5 4.5z"
  }))));
};
export default SvgReportInappropriate;